import { observer } from 'mobx-react-lite'
import { ELearningCourseCategory } from '../../model/ELearningCourseCategory'
import { Chip, Fade } from '@mui/material'
import { startCase } from 'lodash'

export type CategoryItemProp = {
  item: ELearningCourseCategory
  index: number
  selectedSubCategory: string
  clickHandler?: (item: ELearningCourseCategory) => void
}

export const CourseItem = observer(({ item, index, selectedSubCategory, clickHandler }: CategoryItemProp) => {
  return (
    <Fade in={true} timeout={index * 100} mountOnEnter unmountOnExit>
      <Chip
        key={index}
        variant='outlined'
        sx={{ ...styles.chip, ...(selectedSubCategory !== item.id ? '' : { backgroundColor: 'text.secondary' }) }}
        label={startCase(item.titleLocale)}
        onClick={() => clickHandler && clickHandler(item)}
      />
    </Fade>
  )
})

const styles = {
  chip: {
    padding: 5,
    backgroundColor: 'background.paper',
    border: '1px solid',
    borderColor: 'grey.300',
    ':active': {
      boxShadow: 'unset !important',
    },
    fontSize: 12,
  },
}
